import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BookmatchContainer } from './containers/bookmatch/bookmatch.container';
import { DefaultContainer } from './containers/default/default.container';
import { DetailContainer } from './containers/detail/detail.container';
import { ExpandModalContainer } from './containers/expand-modal/expand-modal.container';
import { SearchResultsContainer } from './containers/search-results/search-results.container';
import { getLanguageFromUrl } from './language';

export enum ROUTER_PATH {
  ROOT = '',
  RESULTS = 'results',
  DETAIL = 'detail',
  EXPAND = 'expand',
  BOOKMATCH = 'bookmatch',
}

const routes: Routes = [
  {
    path: ':language',
    pathMatch: 'prefix',
    children: [
      {
        path: ROUTER_PATH.ROOT,
        component: DefaultContainer
      },
      {
        path: ROUTER_PATH.RESULTS,
        redirectTo: ROUTER_PATH.ROOT
      },
      {
        path: ROUTER_PATH.RESULTS + '/:query',
        component: SearchResultsContainer
      },
      {
        path: ROUTER_PATH.DETAIL,
        component: DetailContainer
      },
      {
        path: ROUTER_PATH.EXPAND,
        component: ExpandModalContainer
      },
      {
        path: ROUTER_PATH.BOOKMATCH + '/:bloque',
        component: BookmatchContainer
      },
    ]
  },
  {
    path: '**',
    redirectTo: getLanguageFromUrl()
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
